/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import shortid from 'shortid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { parseShortDateTime, twelveHourTimeFormat } from '../../../../utils/dates';

// eslint-disable-next-line react/prop-types
export default function NonPatientActivityDetails({ nonPatientActivity }) {
  const isNPAWithTravel = nonPatientActivity.address !== null && nonPatientActivity.address.postcode !== '';

  const activityDetails = () => {
    return (
      <div className="clinician-info-box">
        <h6>Activity Details</h6>
        <List className="list-underline">
          <ListItem key="npasp-clinicians-item">
            <ListItemText primary="Clinicians" />
            <span className="divider" />
            <Grid container className="npa-clinician-list">
              {nonPatientActivity.clinicians.map(clinician => (
                <Grid item className="npa-clinician-list-item" key={shortid.generate()}>
                  {clinician.name}
                </Grid>
              ))}
            </Grid>
          </ListItem>
          <ListItem key="npasp-teams-item">
            <ListItemText primary="Teams" />
            <span className="divider" />
            <Grid container className="npa-clinician-list">
              {nonPatientActivity.orgUnits.map(orgUnit => (
                <Grid item className="npa-clinician-list-item" key={shortid.generate()}>
                  {orgUnit.name}
                </Grid>
              ))}
            </Grid>
          </ListItem>
        </List>
      </div>
    );
  };

  const notes = () => {
    return (
      nonPatientActivity.notes && (
        <div className="clinician-info-box">
          <h6>Notes</h6>
          <div className="treatment-description">{nonPatientActivity.notes || '-'}</div>
        </div>
      )
    );
  };

  const activitySchedule = () => {
    return (
      <div className="clinician-info-box">
        <h6>Activity Schedule</h6>
        <List className="list-underline">
          <ListItem key="npasp-dateFrom-item">
            <ListItemText primary="Date From" />
            <span className="divider" />
            <ListItemText secondary={parseShortDateTime(nonPatientActivity.dateFrom)} />
          </ListItem>
          <ListItem key="npasp-dateTo-item">
            <ListItemText primary="Date To" />
            <span className="divider" />
            <ListItemText secondary={parseShortDateTime(nonPatientActivity.dateTo)} />
          </ListItem>
          <ListItem key="npasp-startTime-item">
            <ListItemText primary="Start Time" />
            <span className="divider" />
            <ListItemText secondary={twelveHourTimeFormat(nonPatientActivity.startTime)} />
          </ListItem>
          <ListItem key="npasp-endTime-item">
            <ListItemText primary="End Time" />
            <span className="divider" />
            <ListItemText secondary={twelveHourTimeFormat(nonPatientActivity.endTime)} />
          </ListItem>
          <ListItem key="npasp-duration-item">
            <ListItemText primary="Duration" />
            <span className="divider" />
            <ListItemText secondary={nonPatientActivity.duration} />
          </ListItem>
          <ListItem key="npasp-reccurence-item">
            <ListItemText primary="Recurrence Type" />
            <span className="divider" />
            <ListItemText secondary={nonPatientActivity.recurrenceType} />
          </ListItem>
          <ListItem key="npasp-reccurence-item">
            <ListItemText primary="Recur Every" />
            <span className="divider" />
            <ListItemText secondary={nonPatientActivity.recurEvery} />
          </ListItem>
        </List>
      </div>
    );
  };

  const activityAddress = () => {
    return (
      <div className="clinician-info-box">
        <h6>Activity Address</h6>
        <List className="list-underline">
          <ListItem key="npasp-address1-item">
            <ListItemText primary="Address line 1" />
            <span className="divider" />
            <ListItemText secondary={nonPatientActivity.address.addressLine1 || '-'} />
          </ListItem>
          <ListItem key="npasp-address2-item">
            <ListItemText primary="Address line 2" />
            <span className="divider" />
            <ListItemText secondary={nonPatientActivity.address.addressLine2 || '-'} />
          </ListItem>
          <ListItem key="npasp-address3-item">
            <ListItemText primary="Address line 3" />
            <span className="divider" />
            <ListItemText secondary={nonPatientActivity.address.addressLine3 || '-'} />
          </ListItem>
          <ListItem key="npasp-town-item">
            <ListItemText primary="Town/city" />
            <span className="divider" />
            <ListItemText secondary={nonPatientActivity.address.townCity || '-'} />
          </ListItem>
          <ListItem key="npasp-postcode-item">
            <ListItemText primary="Postcode" />
            <span className="divider" />
            <ListItemText secondary={nonPatientActivity.address.postCode || '-'} />
          </ListItem>
          <ListItem key="npasp-accessDetails-item">
            <ListItemText primary="Access Details" />
            <span className="divider" />
            <ListItemText secondary={nonPatientActivity.address.accessDetails || '-'} />
          </ListItem>
        </List>
      </div>
    );
  };

  const nonPatientDetailsRender = () => {
    return (
      <React.Fragment>
        <div className="sidePanel-content">
          <Grid container spacing={0}>
            <Grid item xs={12} sm={12}>
              {activityDetails()}
              {notes()}
              {activitySchedule()}
              {isNPAWithTravel ? activityAddress() : ''}
            </Grid>
          </Grid>
        </div>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <div className="clinician-info-box">
        <Typography variant="h6" gutterBottom>
          Non Patient Activity Details
        </Typography>
        {nonPatientDetailsRender()}
      </div>
    </React.Fragment>
  );
}
